import { jsx } from "panel";
import { BannerEl } from "common/components/banner";
import { BannerType } from "common/components/banner/types";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor } from "common/components/spinner/types";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement } from "common/components/tooltip/types";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { FileUploaderEl } from "common/components/file-uploader";
import { ExpiresModeOptions, ExpiresModeOptionsI18nKey, ExpiresUnit, ExpiresUnitI18nKey } from "common/types/reports/service-accounts";
import { AutocompleteType } from "common/components/input/types";
import { CsvFormatInfoEl } from "common/widgets/invite-users-modal/csv-format-info";
import { UpgradePlanEl } from "common/widgets/invite-users-modal/upgrade-plan";
import { UserRoleI18nKey } from "common/report/util/saved-entities/constants";
import { CopyToClipboardEl } from "../copy-to-clipboard";
export function template() {
  const {
    currentTab,
    error,
    isLoading,
    orgs,
    selectedOrg,
    serviceAccount,
    userFile,
    userRows
  } = this.state;
  const isServiceAccount = this.helpers.isServiceAccount();
  const isSingleProject = !!this.getProjectIdIfSingleProject();
  const modalHeader = isSingleProject ? this.t("settings.org-settings.invite-users.invite") : this.t("settings.org-settings.invite-users.invite-new-users");
  const InviteUsersRow = (props) => {
    var _props$row, _props$row$projectIds;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-row" }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-column" }, isServiceAccount ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.name")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-input-container" }, /* @__PURE__ */ jsx(InputEl, { sel: ".invite-users-service-account-name", attrs: {
      "error-message": props.row.nameErrorMsg,
      "validation-status": this.helpers.serviceAccountNameValidationStatus(props.row)
    }, props: {
      value: props.row.name
    }, on: {
      input: (ev) => this.helpers.updateServiceAccountName(ev, props.row)
    } }))) : /* @__PURE__ */ jsx(null, null, !props.idx && /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.email-address")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-input-container" }, /* @__PURE__ */ jsx(InputEl, { sel: ".invite-users-input.invite-users-email-input", attrs: {
      type: "text",
      /* autocomplete=off does not work as of Chrome 34 */
      autocomplete: AutocompleteType.InviteUsersAutocompleteOff
    }, props: {
      value: props.row.email
    }, on: {
      input: (ev) => this.helpers.updateUserEmail(ev, props.row),
      focus: this.helpers.clearErrors,
      blur: (ev) => this.helpers.updateEmailError(ev, props.row)
    } }), (props.row.emailError || props.row.emailInfo) && props.row === userRows.find((userRow) => userRow.email === props.row.email) && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "always-show": true,
      type: props.row.emailInfo ? DisplayType.Default : DisplayType.Error,
      placement: Placement.Left
    } }, (() => {
      if (props.row.emailErrorMsg) {
        return props.row.emailErrorMsg;
      }
      return props.row.email && props.row.email.length ? this.t("settings.org-settings.invite-users.enter-valid-email") : this.t("settings.org-settings.invite-users.enter-email");
    })())))), /* @__PURE__ */ jsx("div", { sel: ".invite-users-column" }, !props.idx && /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.org-role")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-input-container" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
      "selected-option": props.row.orgRole ? this.t(UserRoleI18nKey[props.row.orgRole]) : this.t("settings.org-settings.invite-users.select-role"),
      "menu-height": 350,
      size: ButtonSize.Large
    }, props: {
      sections: this.helpers.getOrgRoleSections(props.row)
    }, on: {
      change: (ev) => this.helpers.selectOrgRole(ev, props.row),
      focus: this.helpers.clearErrors
    }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" })), props.row.orgRoleError && props.row === userRows.find((row) => row.orgRoleError) && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "always-show": true,
      type: DisplayType.Error,
      placement: Placement.Top
    } }, this.t("settings.org-settings.invite-users.please-select-role"))), !this.attr("exclude-project-selections") && currentTab === this.helpers.TABS.PROJECT && /* @__PURE__ */ jsx(null, null, !isSingleProject && /* @__PURE__ */ jsx("div", { sel: ".invite-users-column", style: {
      width: "250px"
    } }, (() => {
      const numProjects = props.row.projectIds.length;
      return /* @__PURE__ */ jsx(null, null, !props.idx && /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("mixology.project", {
        context: "plural"
      })), /* @__PURE__ */ jsx("div", { sel: ".invite-users-input-container" }, /* @__PURE__ */ jsx(SelectEl, { style: {
        width: "250px"
      }, attrs: {
        "selected-option": numProjects ? this.t("mixology.project-count", {
          count: numProjects
        }) : this.t("settings.org-settings.invite-users.select-projects"),
        multiple: true,
        "show-select-all": true,
        size: ButtonSize.Large,
        "menu-width": 250
      }, props: {
        sections: this.helpers.getProjectSections(props.row)
      }, on: {
        change: (ev) => this.helpers.toggleProjectSelected(ev, props.row),
        selectAll: (ev) => this.helpers.toggleAllProjectsSelected(ev, props.row),
        focus: this.helpers.clearErrors
      } })), props.row.projectError && props.row === userRows.find((row) => row.projectError) && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        "always-show": true,
        type: DisplayType.Error,
        placement: Placement.Top
      } }, this.t("settings.org-settings.invite-users.please-select-project")));
    })()), /* @__PURE__ */ jsx("div", { sel: ".invite-users-column" }, !props.idx && /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.project-role")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-input-container" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
      "selected-option": props.row.projectRole ? this.t(UserRoleI18nKey[props.row.projectRole]) : this.t("settings.org-settings.invite-users.select-role"),
      "menu-height": 300,
      size: ButtonSize.Large
    }, props: {
      sections: this.helpers.getProjectRoleSections()
    }, on: {
      change: (ev) => this.helpers.selectProjectRole(ev, props.row),
      focus: this.helpers.clearErrors
    } }), props.row.projectRoleError && props.row === userRows.find((row) => row.projectRoleError) && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "always-show": true,
      type: DisplayType.Error,
      placement: Placement.Right
    } }, this.t("settings.org-settings.invite-users.please-select-role")))), isServiceAccount && /* @__PURE__ */ jsx("div", { sel: ".invite-users-column.invite-users-expires-column" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-expires-container" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.expires")), (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.expires ? /* @__PURE__ */ jsx("div", { sel: ".expires-form" }, /* @__PURE__ */ jsx(InputEl, { sel: ".invite-users-expires-interval-input", attrs: {
      type: "number"
    }, props: {
      value: String(props.row.expires.interval)
    }, on: {
      input: (ev) => this.helpers.updateExpiresInterval(ev, props.row)
    } }), /* @__PURE__ */ jsx(SelectEl, { sel: ".invite-users-expires-unit-selector", attrs: {
      "menu-width": 100,
      sections: [{
        items: Object.values(ExpiresUnit).map((unit) => {
          return {
            label: this.t(ExpiresUnitI18nKey[unit]),
            value: unit,
            isSelected: unit === props.row.expires.unit
          };
        })
      }]
    }, on: {
      change: (ev) => this.helpers.selectExpiresUnit(ev, props.row)
    } })) : /* @__PURE__ */ jsx(SelectEl, { sel: ".invite-users-expires-mode-selector", attrs: {
      "menu-width": 100,
      sections: [{
        items: Object.values(ExpiresModeOptions).map((mode) => {
          return {
            label: this.t(ExpiresModeOptionsI18nKey[mode]),
            value: mode,
            isSelected: mode === ExpiresModeOptions.Never
          };
        })
      }]
    }, on: {
      change: (ev) => this.helpers.selectExpirationMode(ev, props.row)
    } })))), currentTab === this.helpers.TABS.TEAM && /* @__PURE__ */ jsx("div", { sel: ".invite-users-column" }, (() => {
      const numTeams = props.row.teamNames.length;
      return /* @__PURE__ */ jsx(null, null, !props.idx && /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("settings.org-settings.invite-users.teams")), /* @__PURE__ */ jsx(SelectEl, { attrs: {
        "selected-option": numTeams ? this.t("settings.org-settings.invite-users.team-count", {
          count: numTeams
        }) : this.t("settings.org-settings.invite-users.select-teams"),
        multiple: true,
        "show-select-all": true,
        size: ButtonSize.Large
      }, props: {
        sections: this.helpers.getTeamSections(props.row)
      }, on: {
        change: (ev) => this.helpers.toggleTeamSelected(ev, props.row),
        selectAll: (ev) => this.helpers.toggleAllTeamsSelected(ev, props.row)
      } }));
    })()), userRows.length > 1 && /* @__PURE__ */ jsx("div", { sel: ".invite-users-remove-button", on: {
      click: () => this.helpers.clickedDeleteButton(props.row)
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "x"
    } })))), ((_props$row$projectIds = props.row.projectIdsToDowngrade) === null || _props$row$projectIds === void 0 ? void 0 : _props$row$projectIds.length) > 0 && (() => {
      const downgradedProjectsString = this.helpers.getDowngradedProjectsString(props.row);
      const allDowngradedProjectsString = this.helpers.getAllDowngradedProjectsString(props.row);
      return /* @__PURE__ */ jsx("div", { sel: ".invite-users-row-error" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-error-title" }, this.t("settings.org-settings.invite-users.cant-assign-owner-role", {
        numProjects: props.row.projectIdsToDowngrade.length
      })), props.row.seeAll ? /* @__PURE__ */ jsx("div", { sel: ".projects-list" }, allDowngradedProjectsString) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".project-list" }, downgradedProjectsString), downgradedProjectsString.length < allDowngradedProjectsString.length && /* @__PURE__ */ jsx("div", { sel: ".invite-users-see-all", on: {
        click: () => this.helpers.seeAllDowngradedProjects(props.idx)
      } }, this.t("settings.org-settings.invite-users.see-all"))));
    })());
  };
  return /* @__PURE__ */ jsx("div", { sel: ".settings-screen-modal", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ModalEl, { sel: ".invite-users-modal", attrs: {
    open: this.attr("open")
  }, on: {
    change: this.helpers.modalVisibilityChanged
  }, "data-sentry-element": "ModalEl", "data-sentry-source-file": "template.tsx" }, isServiceAccount ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-header" }, isLoading ? /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    color: SpinnerColor.White
  } }) : this.t("settings.org-settings.invite-users.create-service-account")), error ? /* @__PURE__ */ jsx(BannerEl, { sel: ".invite-users-error-banner", attrs: {
    theme: "warn",
    type: BannerType.Embedded,
    "header-text": this.t("settings.org-settings.invite-users.create-service-account-error"),
    "body-text": error
  } }) : null, !serviceAccount ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-add-users" }, userRows.map((row, idx) => /* @__PURE__ */ jsx(InviteUsersRow, { row, idx }))), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-bottom-buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: isLoading || !this.attr("open") || !selectedOrg || this.helpers.hasInvalidName()
  }, on: {
    click: this.helpers.clickedSave
  } }, this.t("common.create")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", on: {
    click: this.helpers.clickedCancel
  } }, this.t("common.cancel")))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".copy-container" }, /* @__PURE__ */ jsx("div", { sel: ".copy-token-warning.mp-font-weight-bold" }, this.t("settings.org-settings.invite-users.save-secret-info")), /* @__PURE__ */ jsx("div", { sel: ".modal-content-container" }, /* @__PURE__ */ jsx("div", { sel: ".modal-content-row" }, /* @__PURE__ */ jsx(CopyToClipboardEl, { attrs: {
    label: this.t("settings.org-settings.invite-users.username"),
    value: serviceAccount.username
  } })), /* @__PURE__ */ jsx("div", { sel: ".modal-content-row" }, /* @__PURE__ */ jsx(CopyToClipboardEl, { attrs: {
    label: this.t("settings.org-settings.invite-users.secret"),
    value: serviceAccount.secret
  } })))), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-bottom-buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", on: {
    click: this.helpers.handleClickedDone
  } }, this.t("common.done"))))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-header" }, isLoading ? /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    color: SpinnerColor.White
  } }) : modalHeader), (!this.attr("exclude-teams") || !this.attr("exclude-bulk-invite")) && /* @__PURE__ */ jsx("div", { sel: ".mp-modal-tab-section" }, /* @__PURE__ */ jsx(ToggleEl, { attrs: {
    selected: currentTab,
    theme: ToggleTheme.TabBar
  }, on: {
    select: this.helpers.selectTab
  } }, /* @__PURE__ */ jsx("mp-toggle-option", { attrs: {
    value: this.helpers.TABS.PROJECT
  } }, isSingleProject ? this.t("settings.org-settings.invite-users.invite") : this.t("settings.org-settings.invite-users.invite-to-projects")), !this.attr("exclude-teams") && /* @__PURE__ */ jsx("mp-toggle-option", { attrs: {
    value: this.helpers.TABS.TEAM
  } }, this.t("settings.org-settings.invite-users.invite-to-teams")), !this.attr("exclude-bulk-invite") && /* @__PURE__ */ jsx("mp-toggle-option", { attrs: {
    value: this.helpers.TABS.BULK
  } }, this.t("settings.org-settings.invite-users.bulk-invite")))), orgs.length > 1 ? /* @__PURE__ */ jsx("div", { sel: ".invite-users-select-org" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-title" }, this.t("mixology.organization").toLowerCase()), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    "selected-option": selectedOrg ? selectedOrg.name : this.t("settings.org-settings.invite-users.select-org"),
    size: ButtonSize.Large
  }, props: {
    sections: this.helpers.getOrgSections()
  }, on: {
    change: this.helpers.selectOrg
  } })) : null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-add-users", class: {
    "invite-users-hidden": !selectedOrg
  } }, selectedOrg && this.helpers.isOverSeatCount() ? /* @__PURE__ */ jsx("div", { sel: ".invite-users-warning-text-container" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "warning"
  } }), /* @__PURE__ */ jsx("div", { sel: ".invite-users-warning-text" }, this.t("settings.org-settings.invite-users.out-of-seats-upsell"), " ", this.helpers.hasBillingPerms() ? /* @__PURE__ */ jsx(UpgradePlanEl, { onClickUpsell: this.helpers.trackUpsellClick }) : this.t("settings.org-settings.invite-users.contact-admin-to-upgrade"))) : null, currentTab === this.helpers.TABS.PROJECT || currentTab === this.helpers.TABS.TEAM ? /* @__PURE__ */ jsx(null, null, selectedOrg ? userRows.map((row, idx) => /* @__PURE__ */ jsx(InviteUsersRow, { row, idx })) : null, /* @__PURE__ */ jsx("div", { sel: ".invite-users-add-another-user" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-add-another-user-button", on: {
    click: this.helpers.clickedAddMoreUser
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "plus"
  } }), this.t("settings.org-settings.invite-users.add-another-user")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-add-another-user-alignment" }))) : null, currentTab === this.helpers.TABS.BULK ? /* @__PURE__ */ jsx("div", { sel: ".invite-users-bulk-add-users" }, /* @__PURE__ */ jsx("div", { sel: ".invite-users-bulk-add-users-title" }, this.t("settings.org-settings.invite-users.file-name")), /* @__PURE__ */ jsx("div", { sel: ".invite-users-bulk-add-file-uploader" }, /* @__PURE__ */ jsx(FileUploaderEl, { attrs: {
    accept: "text/csv",
    label: this.t("settings.org-settings.invite-users.select-csv"),
    "completed-filename": userFile && userFile.name ? userFile.name : "",
    "enable-delete": true,
    "max-filename-chars": 120
  }, on: {
    change: this.helpers.fileStatusChanged,
    delete: this.helpers.removeSelectedFile
  } }), userFile && userFile.error ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    type: DisplayType.Error,
    placement: Placement.Right
  } }, userFile.errorMsg || this.t("settings.org-settings.invite-users.please-select-csv")) : null), /* @__PURE__ */ jsx("div", { sel: ".invite-users-bulk-add-users-subtitle" }, /* @__PURE__ */ jsx(CsvFormatInfoEl, null))) : null), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-bottom-buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: isLoading || !this.attr("open") || this.helpers.isOverSeatCount() || !selectedOrg
  }, on: {
    click: this.helpers.clickedSave
  } }, currentTab === this.helpers.TABS.BULK ? this.t("settings.org-settings.invite-users.upload") : this.t("settings.org-settings.invite-users.invite")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-button", on: {
    click: this.helpers.clickedCancel
  } }, this.t("common.cancel"))))));
}
